import { useState } from "react";
import { Fab } from "@remo-co/ui-core/src/components/Fab";
import { Edit } from "@remo-co/ui-core/src/icons/Edit";
import { PlayArrow } from "@remo-co/ui-core/src/icons/PlayArrow";
import { Stop } from "@remo-co/ui-core/src/icons/Stop";
import { useSelector } from "react-redux";
import { selectCurrentTheaterId } from "modules/theater/selectors";
import useSystemClock from "modules/system/hooks/useSystemClock";
import classNames from "classnames";
import TimerSetup from "modules/timer/TimerSetup";
import timerFirebase from "../../timer.firebase";
import {
  selectIsTimerRunning,
  selectTimerSetupParams,
} from "../../redux/selectors";
import { useStyles } from "./styles";

export const TimerManagerPanel = () => {
  const isTimerRunning = useSelector(selectIsTimerRunning);
  const [setupVisible, setSetupVisible] = useState(true);
  const theaterId = useSelector(selectCurrentTheaterId);
  const { getCurrentTime } = useSystemClock();
  const styles = useStyles();
  const { roundDuration, rounds, breakDuration } = useSelector(
    selectTimerSetupParams,
  );

  const handleEditClick = () => {
    setSetupVisible(!setupVisible);
  };

  const handleStartStopClick = async () => {
    if (theaterId !== null) {
      if (isTimerRunning) {
        timerFirebase.stopTimer(theaterId);
      } else {
        timerFirebase.startTimer(theaterId, getCurrentTime());
      }
      setSetupVisible(false);
    }
  };

  const handleSetParams = async (
    roundsVal: string,
    minutesVal: string,
    bufferTimeVal: string,
  ) => {
    const data = {
      rounds: +roundsVal,
      roundDuration: +minutesVal,
      breakDuration: +bufferTimeVal,
    };

    if (theaterId !== null) {
      await timerFirebase.setTimerParams(theaterId, data);
    }
    setSetupVisible(!setupVisible);
  };

  return (
    <div data-testid="timermanager-panel" className={styles.buttonContainer}>
      <Fab
        className={classNames(styles.startButton, styles.editIcon)}
        disabled={isTimerRunning}
        onClick={handleEditClick}
        color="secondary"
      >
        <Edit className={styles.icon} />
      </Fab>
      {setupVisible && !isTimerRunning && (
        <TimerSetup
          minutes={`${roundDuration}`}
          rounds={`${rounds}`}
          bufferTime={`${breakDuration}`}
          onSet={handleSetParams}
        />
      )}
      <Fab
        className={classNames(styles.startButton, {
          [styles.stop]: isTimerRunning,
          [styles.play]: !isTimerRunning,
        })}
        onClick={handleStartStopClick}
        color="primary"
        data-testid="timer-manager-panel-toggle"
      >
        {isTimerRunning ? (
          <Stop
            className={styles.icon}
            data-testid="timer-manager-panel-stop-timer"
          />
        ) : (
          <PlayArrow
            className={styles.icon}
            data-testid="timer-manager-panel-start-timer"
          />
        )}
      </Fab>
    </div>
  );
};
